<template>
  <b-modal
    id="modal-ads-campaign-form"
    ref="modalAdsCampaignFormRef"
    hide-footer
    :title="modalTitle"
    @hide="hideModal"
  >
    <form class="needs-validation" @submit.prevent="handleAdsCampaignAction">
      <div class="d-block form-group">
        <label for="name" class="d-block">Campaign (<span class="text-danger">*</span>)</label>
        <b-form-input
          v-model="adsCampaignForm.campaign"
          class="form-control"
          type="text"
          name="campaign"
          placeholder="GLB_search_general_may_24"
          required
        />
      </div>
      <div class="d-block form-group">
        <label for="name" class="d-block">Name (<span class="text-danger">*</span>)</label>
        <b-form-input
          v-model="adsCampaignForm.name"
          class="form-control"
          type="text"
          name="name"
          required
        />
      </div>
      <div class="d-block form-group">
        <label for="start" class="d-block">Start date</label>
        <b-form-input
          v-model="adsCampaignForm.start"
          class="form-control"
          type="datetime-local"
          name="start"
        />
      </div>
      <div class="d-block form-group">
        <label for="end" class="d-block">End date</label>
        <b-form-input
          v-model="adsCampaignForm.end"
          class="form-control"
          type="datetime-local"
          name="end"
        />
      </div>
      <div class="d-block form-group">
        <label for="source" class="d-block">Source</label>
        <b-form-input
          v-model="adsCampaignForm.source"
          class="form-control"
          type="text"
          name="source"
          placeholder="gg"
        />
      </div>
      <div class="d-block form-group">
        <label for="medium" class="d-block">Medium</label>
        <b-form-input
          v-model="adsCampaignForm.medium"
          class="form-control"
          type="text"
          name="medium"
          placeholder="search"
        />
      </div>
      <div class="d-block form-group">
        <label for="pic" class="d-block">Pic</label>
        <input
          v-model="adsCampaignForm.pic"
          class="form-control"
          type="text"
          name="pic"
          placeholder="Daniel"
        />
      </div>
      <div class="text-center">
        <button type="submit" class="mr-2 btn btn-primary">
          {{ textAction }}
          <i v-if="isLoading" class="fa fa-spinner fa-spin"></i>
        </button>
        <button
          type="button"
          class="btn btn-light"
          @click="$emit('cancel')"
        >
          Cancel
        </button>
      </div>
    </form>
  </b-modal>
</template>

<script>
import utils from "@/utils"
import AdsCampaignAPI from "@/api/adsCampaign"

const ADS_CAMPAIGN_FORM = {
  campaign: "", // required
  name: "", // required
  start: null,
  end: null,
  source: "",
  medium: "",
  pic: "",
}

export default {
  props: {
    type: {
      type: String,
      default: "create",
      validator: (value) => ["create", "update"].includes(value),
    },
    adsCampaign: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      adsCampaignForm: { ...ADS_CAMPAIGN_FORM },
      isLoading: false,
    }
  },
  computed: {
    isCreate() {
      return this.type === "create"
    },
    isEdit() {
      return this.type === "update"
    },
    textAction() {
      return this.isCreate ? "Create Ads Campaign" : "Update Ads Campaign"
    },
    modalTitle() {
      return this.isCreate ? "Create Ads Campaign" : "Update Ads Campaign"
    },
  },
  mounted() {
    this.$refs["modalAdsCampaignFormRef"].show()

    if (this.isEdit) {
      this.adsCampaignForm = this.parseAdsCampaignForm(this.adsCampaign)
    }
  },
  methods: {
    hideModal() {
      this.$emit("hide")
    },
    handleAdsCampaignAction() {
      if (this.isCreate) {
        this.createAdsCampaign()
      } else {
        this.updateAdsCampaign()
      }
    },
    handleAfterAdsCampaignAction() {
      this.hideModal()
      this.$emit("refresh")
    },
    async createAdsCampaign() {
      this.isLoading = true

      try {
        const payload = this._makePayload()

        await AdsCampaignAPI.createAdsCampaign(payload)

        utils.showToastSuccess("Ads Campaign created successfully")
        this.handleAfterAdsCampaignAction()
      } catch (error) {
        utils.showToastError("Failed to create Ads Campaign")
      } finally {
        this.isLoading = false
      }
    },
    async updateAdsCampaign() {
      this.isLoading = true

      try {
        const payload = this._makePayload()

        await AdsCampaignAPI.patchAdsCampaign(payload.id, payload)

        utils.showToastSuccess("Ads Campaign updated successfully")
        this.handleAfterAdsCampaignAction()
      } catch (error) {
        utils.showToastError("Failed to update Ads Campaign")
      } finally {
        this.isLoading = false
      }
    },
    _makePayload() {
      const payload = Object.entries(this.adsCampaignForm).reduce(
        (acc, [key, value]) => {
          if (value !== undefined && value !== null) {
            acc[key] = value
          }

          return acc
        },
        {}
      )

      if (payload.start) {
        payload.start = utils.convertToTimestampTz(payload.start)
      }

      if (payload.end) {
        payload.end = utils.convertToTimestampTz(payload.end)
      }

      return payload
    },
    parseAdsCampaignForm(adsCampaign) {
      return {
        ...ADS_CAMPAIGN_FORM,
        ...adsCampaign,
        start: adsCampaign.start ? utils.convertToDateTimeLocal(adsCampaign.start) : null,
        end: adsCampaign.end ? utils.convertToDateTimeLocal(adsCampaign.end) : null,
      }
    },
  },
}
</script>